import * as React from 'react';
import { useState } from 'react';
import { Snackbar, SnackbarProps } from '@mui/material';
import { ApolloErrorPayload } from '../../../../types';
import { useToggleable } from '../../../../hooks';
import cn from 'classnames';
import { useTheme } from '../../../../theme';
import { useTranslation } from 'react-i18next';
import { APOLLO_ERRORS_EVENT } from '@shared/api/apollo';

const OPERATION_NAME = 'SaveOrderServices';

type Props = Omit<SnackbarProps, 'open' | 'onClose' | 'message'>;

const SeatMapError: React.FC<Props> = props => {
	const theme = useTheme('SeatMap').SeatMapError;
	const { t } = useTranslation('SeatMap');

	const [msg, setMsg] = useState<string>(null);

	const { isOpen, close, open } = useToggleable(false);

	React.useEffect(() => {
		const eventHandler = (event: any) => {
			const customEvent = event as CustomEvent<ApolloErrorPayload>;
			if (customEvent.detail.operationName === OPERATION_NAME && customEvent.detail.message?.length > 0) {
				setMsg(t(customEvent.detail.message));
				open();
			}
		};
		document.addEventListener(APOLLO_ERRORS_EVENT, eventHandler);

		return () => document.removeEventListener(APOLLO_ERRORS_EVENT, eventHandler);
	}, []);

	return (
		<Snackbar
			anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
			className={cn(props.className, theme.root)}
			slotProps={{ content: { className: theme.content, classes: { message: theme.message } } }}
			open={isOpen}
			onClose={close}
			message={msg}
			{...props}
		/>
	);
};

export default SeatMapError;
